{
  "static-content-online-booking-process": {
    "buttons": {},
    "text": {
      "title": "Rezervace online je hračka!",
      "description": "Najděte si vybraný salon a vyberte si požadovanou službu, datum a čas. Potvrďte své údaje a vše je připraveno!",
      "step-confirm-title": "To je vše",
      "step-confirm-description": "Okamžitě obdržíte potvrzení rezervace a vše je připraveno",
      "step-find-salon-title": "Najít salon",
      "step-find-salon-description": "Vyhledání salonu podle místa, ošetření nebo data",
      "step-select-date-title": "Výběr data a času",
      "step-select-date-description": "Můžete vybrat libovolné dostupné datum a čas",
      "step-select-service-title": "Zvolte službu",
      "step-select-service-description": "Vyberte si preferovanou službu"
    }
  }
}
